/**
 *  @param {Object}
 *  property: errorName - short name / key of the error
 *  property: errorMessage - description of the error
 *  property: pluginName - pluginName that sends the error
 *  deploymentId, // optional - because in some cases this is not needed. For example when rejecting during to plugin permission not available
 *  data: response or error data  // optional - should not contain customer info but only telemetry data such as correlation_id, etc
 */
export function newRelicErrorMetrics() {
  const oNewRelicErrorMetrics ={

    bNewRelicReady: false,

    subscribeNewRelicReady: ()=>{
      Genesys('subscribe', 'NewRelic.ready', () => {
        newRelicErrorMetrics.bNewRelicReady = true;
      });
    },

    newRelicError:(oError)=>{
      if (newRelicErrorMetrics.bNewRelicReady && oError && Object.keys(oError).length) {
        const { errorName, errorMessage, pluginName, deploymentId, data } = oError;
        const oCustomErrorAttributes = {
          errorName: errorName || '', /** adding errorName as a custom attribute to filter out error name in new relic */
          errorDesc: errorMessage || '', /** changed the property name error to errorDesc for more sense. Note: naming the attribute name as 'errorMessage' is not getting tracked as it seems like reserved word */
          pluginName: pluginName || '',
          deploymentId: deploymentId || '',
        };

        if (data && Object.keys(data).length) {
          oCustomErrorAttributes.data = data;
        }

        Genesys('command', 'NewRelic.error', {
          name: errorName,
          data: oCustomErrorAttributes,
        });
      }
    },
  };

  return oNewRelicErrorMetrics;
}
